export default "/img/NI.7b07652dcc7d9fb86ed39b714d42fa8f.png";